import { http, HttpResponse } from 'msw'

import { allClients } from 'app/mocks/data/park/clients'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { ClientsRequest } from 'app/types/park/client'

export const getAllClients = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.clients.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerIdsFilter = searchParams.get('client__id__in')
        const nameFilter = searchParams.get('name__icontains')

        let allClientsFiltered = allClients

        // Manager filter
        if (managerIdsFilter) {
            const managerIdsSplit = queryIntoArrayNumber(managerIdsFilter)

            allClientsFiltered = allClientsFiltered.filter((client) =>
                managerIdsSplit.includes(client.client.id),
            )
        }

        // Name filter
        if (nameFilter) {
            allClientsFiltered = allClientsFiltered.filter((client) =>
                client.name.toLowerCase().includes(nameFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allClientsFiltered.length > limit
                ? offset + limit
                : allClientsFiltered.length

        const results = allClientsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allClientsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<ClientsRequest>({
            next,
            results,
        })
    },
)
